module.exports = __webpack_public_path__ + "img/dp-portfolio-06.494f1ea0.jpg";